module.exports = require('./src/liquidFill');



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0